<template>
  <v-btn-toggle
    v-bind="$attrs"
    v-on="$listeners"
    v-model="toggleCardView"
    :active-class="activeClass"
    :color="color"
    :mandatory="mandatory"
    style="background-color: rgb(244, 244, 247); padding-left: 24px;"
  >
    <v-btn
      aria-label="grid"
      :aria-pressed="gridActive.toString()"
      @click="leftClickHandler"
    >
      <v-icon>grid_on</v-icon>
    </v-btn>
    <v-btn
      aria-label="list"
      :aria-pressed="listActive.toString()"
      @click="rightClickHandler"
    >
      <v-icon>list</v-icon>
    </v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  name: 'ToggleButtonGroup',
  props: {
    activeClass: {
      type: String,
      default: 'activeButton'  // override the default value 'v-item--active' in v-btn-toggle
    },
    color: {
      type: String,
      default: 'primary'  // override the default value 'undefined' in v-btn-toggle
    },
    mandatory: {
      type: Boolean,
      default: true   // override the default value 'false' in v-btn-toggle
    },
    leftClickHandler: {
      type: Function,
      default: () => {
      },
    },
    rightClickHandler: {
      type: Function,
      default: () => {
      }
    }
  },
  data() {
    return {
      toggleCardView: 0,
    }
  },
  computed: {
    gridActive() {
      return this.toggleCardView === 0;
    },
    listActive() {
      return this.toggleCardView === 1;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';

.activeButton {
  background-color: $ads-navy !important;

  .v-icon {
    color: $ads-white !important;
  }
}

.activeButton:focus {
  outline: 3px solid -webkit-focus-ring-color !important;
}
</style>
